import { useEffect } from "react";
import { Newspaper } from "lucide-react";
import Seo from "@/components/Seo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useLang } from "@/i18n/LanguageContext";

const LOGO_IMG = "/img/n148kmw9_image.webp";
const SORO_EMBED_SRC = "https://app.trysoro.com/api/embed/25f9799a-2642-4c27-b853-f59357fca1d0";

const BlogPage = () => {
  const { t } = useLang();

  // Inject the Soro AI blog embed script once on mount.
  useEffect(() => {
    const script = document.createElement("script");
    script.src = SORO_EMBED_SRC;
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Seo
        title="Blog | EffectDeal – Dlouhodobý pronájem vozidel"
        description="Novinky, tipy a rady ze světa dlouhodobého pronájmu vozidel. Čtěte blog EffectDeal."
        path="/blog"
      />
      <nav className="fixed top-0 left-0 right-0 z-50 nav-glass" data-testid="blog-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16 sm:h-20">
            <a href="/" className="flex items-center gap-2 sm:gap-3" data-testid="blog-logo">
              <img src={LOGO_IMG} alt="EffectDeal" className="w-8 h-8 sm:w-10 sm:h-10 object-contain" />
              <span className="font-['Cabinet_Grotesk'] font-bold text-lg sm:text-xl tracking-wide">EFFECTDEAL</span>
            </a>
            <div className="flex items-center gap-3">
              <LanguageSwitcher />
              <a href="/" className="hidden sm:inline text-sm text-zinc-400 hover:text-white transition-colors" data-testid="blog-back-home">
                {t("common.backHome")}
              </a>
            </div>
          </div>
        </div>
      </nav>

      <main className="pt-24 pb-16 px-4 sm:px-6" data-testid="blog-page">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 sm:mb-12">
            <div className="inline-flex items-center gap-2 text-indigo-400 font-medium tracking-widest uppercase text-xs sm:text-sm mb-4">
              <Newspaper className="w-4 h-4 sm:w-5 sm:h-5" />
              <span>{t("nav.blog")}</span>
            </div>
            <h1 className="font-['Cabinet_Grotesk'] text-3xl sm:text-4xl lg:text-5xl font-bold">EffectDeal Blog</h1>
          </div>

          {/* Soro AI blog embed mount point */}
          <div id="soro-blog" data-testid="soro-blog-embed" />
        </div>
      </main>

      <footer className="py-8 px-4 border-t border-white/5">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-zinc-600 text-xs">© 2024 EffectDeal. {t("common.rights")}</p>
        </div>
      </footer>
    </div>
  );
};

export default BlogPage;
